import { useAuthSync } from './useAuthSync';

/**
 * Hook to ensure user exists in database and handle auto-creation
 * This should be used in the main App component after authentication
 * 
 * @deprecated Consider using useAuthSync directly instead
 */
export const useUserAutoCreation = () => {
  const { 
    user: userProfile, 
    isLoading, 
    error, 
    refreshUserProfile 
  } = useAuthSync();

  return {
    userProfile,
    isLoading,
    error,
    refetch: refreshUserProfile
  };
};
